// extracted by mini-css-extract-plugin
module.exports = {"ads_imageContainer":"Ads_ads_imageContainer___iC0D","ads_label":"Ads_ads_label__uVEH9","ads":"Ads_ads__9zYwR","ads_link":"Ads_ads_link__z5zlh"};